import { useLocation } from 'react-router';
import { useGTMDataLayer } from '../../../hooks/GTM/useGTMDataLayer';

interface TrackProps {
  cta_position: string;
  text: string;
  url?: string;
}

export const useTrackCTA = () => {
  const location = useLocation();
  const dataLayer = useGTMDataLayer();

  const trackCTA = ({ cta_position, text, url }: TrackProps) => {
    const { href } = window.location;
    const urlObject = new URL(href);

    let cta_url = url || href;
    if (url && url?.startsWith('/')) cta_url = `${window?.location?.origin}${url}`;

    dataLayer?.push({
      event: 'cta_click',
      cta_text: text,
      cta_position,
      cta_location: location.pathname,
      cta_url,
      cta_hostname: urlObject.hostname,
    });
  };

  return trackCTA;
};
